<template>
  <footer class="dark main-footer">
    <div class="page-container">
      <ul class="footer-list footer-list-main">
        <li>
          <h2 class="text-xl" v-accent="content.addres.header"></h2>
          <h3 class="text-s"><strong>{{content.addres.subheader}}</strong></h3>
          <p class="text-xs">
            <span v-for="(address, index) in content.addres.description"
                  :key="'address-' + index"
                  v-html="address"
                  class="d-inline-block"></span>
          </p>
        </li>
        <li>
          <ul v-if="content.links.length" class="footer-list-simple">
            <li v-for="(item, index) in content.links" :key="index + 'links'">
              <router-link :to="{name: item.slug}">
                <svg>
                  <use xlink:href="#tringleSvg"></use>
                </svg>
                <h3 class="text-s" v-accent.uppercase="item.header"></h3>
              </router-link>
            </li>
          </ul>
          <span v-else>
            &nbsp;
          </span>
        </li>
        <li>
          <h2 class="text-xl no-letter-spacing" v-accent="content.newsletter.header"></h2>
          <form action="#"
                method="post"
                @submit.prevent="submitNewsletterForm()"
                novalidate="true" >
            <ul class="list-clean"
                :class="{ 'has-error' : displayNewsletterErrors }">
              <li v-if="(newsletterErrors && !isNewsletterSignin) || displayNewsletterErrors">
                <small>{{ displayNewsletterErrors }}</small>
              </li>
              <li v-if="isNewsletterSignin">
                <p>{{ content.newsletter.thanks }}</p>
              </li>
              <li class="input-wrapper" v-if="!isNewsletterSignin">
                <input type="email"
                  class="text-xs"
                  name="newsletter-email"
                  v-model="newsletterFormData['newsletter-email']"
                  @focus="clearNewsletterErrors"
                  @blur="checkForm"
                  :placeholder="content.newsletter.placeholder" />
                <button type="submit"
                  class="text-s">
                  {{content.newsletter.submit}}
                </button>
              </li>
              <li v-if="!isNewsletterSignin">
                <label class="checkbox-item">
                  <input type="checkbox"
                        name="newsletter-accepted-privacy"
                        value="true"
                        v-model="newsletterFormData['newsletter-accepted-privacy']" />
                  <span class="checkbox-item-label text-xs">
                    {{ contactData.emailNotification.acceptTerms }}
                    <router-link :to="{ name: 'privacy'}">
                      {{ contactData.emailNotification.acceptTermsLink }}
                    </router-link>
                  </span>
                </label>
              </li>
            </ul>
          </form>
        </li>
      </ul>
      <div class="copy text-xs">
        <p class="copy-left" v-if="content.copy.text">{{ content.copy.text }}</p>
        <p class="copy-right">
          <span v-if="content.copy.design">{{ content.copy.design }} <a href="http://ergodesign.pl/" target="_blank" rel="nofollow">Ergo Design</a> | </span>
          <span v-if="content.copy.implementation">{{ content.copy.implementation }} <a href="https://smultron.software" target="_blank" rel="nofollow">Smultron</a></span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'mainFooter',
  props: ['content'],
  data: function () {
    return {
      newsletterFormData: {
        'newsletter-email': '',
        'newsletter-accepted-privacy': false
      },
      displayNewsletterErrors: null
    }
  },
  methods: {
    ...mapActions([
      'sendNewsletterForm',
      'clearNewsletterErrors'
    ]),
    validateEmail (value) {
      const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      return emailRegex.test(value)
    },
    checkForm () {
      this.displayNewsletterErrors = null
      if (!this.validateEmail(this.getNewsletterEmail)) {
        this.displayNewsletterErrors = this.errorData.incorrectEmail
      } else {
        if (!this.getNewsletterAccept) {
          this.displayNewsletterErrors = this.errorData.noApproval
        }
      }
    },
    getNewsletterErrors () {
      let errorMsg = ''
      switch (this.newsletterErrors) {
        case 404:
          errorMsg = this.errorData.networkError
          break
        default:
          errorMsg = this.newsletterErrors
          break
      }
      return errorMsg + ' ' + this.errorData.tryAgain
    },
    submitNewsletterForm () {
      this.checkForm()
      if (this.displayNewsletterErrors || this.isNewsletterSignin) { return false }
      this.sendNewsletterForm(this.getNewsletterEmail)
    }
  },
  computed: {
    ...mapGetters([
      'isNewsletterSignin',
      'newsletterErrors',
      'contactData',
      'errorData'
    ]),
    getNewsletterEmail () {
      return this.newsletterFormData['newsletter-email']
    },
    getNewsletterAccept () {
      return this.newsletterFormData['newsletter-accepted-privacy']
    }
  },
  watch: {
    newsletterErrors (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.displayNewsletterErrors = this.getNewsletterErrors()
      }
    },
    getNewsletterEmail (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.displayNewsletterErrors = (this.validateEmail(newVal) ? this.errorData.incorrectEmail : null)
      }
    },
    getNewsletterAccept (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.displayNewsletterErrors = (newVal ? this.errorData.noApproval : null)
      }
    }
  },
  mounted () {
    this.clearNewsletterErrors()
  }
}
</script>

<style scoped lang="scss">
footer {
  .only-mobile {
    display: none;
    margin: 10px 0 !important;
    @include tablet {
      display: block;
      svg {
        display: none;
      }
    }
  }
  .page-container {
    padding: 27px 0 40px;
    @include mobile {
      padding: 48px 0;
      // padding: 17px 5vw 30px;
    }
  }
  // padding: 20px;
  text-align: left;
}
.heading {
  @include tablet {
    display: none;
  }
}
h2 {
  letter-spacing: 0.02em;
  &.no-letter-spacing {
    letter-spacing: 0;
  }
}
.icon {
  width: 16px;
  height: 16px;
  overflow: hidden;
  color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  svg {
    width: 100%;
    height: 100%;
  }
  @include tablet {
    width: 26px;
    height: 26px;
  }
}
// .icon-instagram {
//   background-image: url(../assets/images/icons/icon_instagram.svg);
// }
// .icon-facebook {
//   background-image: url(../assets/images/icons/icon_facebook.svg);
// }
.dark {
  background-color: $bg-dark;
  color: $text-light;
}
a {
  text-decoration: none;
  color: $text-accent;
  p {
    color: $text-light;
  }
}
strong {
  color: $text-accent;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 25px;
  @include tablet {
    display: none;
  }
  >li {
    position: relative;

    &:nth-child(3n+1) {
      width: 23vw;
    }
    &:nth-child(3n+2) {
      width: 21vw;
    }
    &:nth-child(3n+3) {
      width: 25vw;
    }
  }
  h2 {
    margin: 23px 0 40px;
    font-weight: 600;
    @include mobile {
      margin: 23px 0 27px;
    }
  }
  h3 {
    margin: 6px 0 2px;
    font-weight: 600;
  }
  p {
    margin: 2px 0 0;
    font-weight: 500;
    line-height: 20px;
    @include mobile {
      letter-spacing: 0.02em;
    }
  }
  a {
    position: relative;
    svg {
      position: absolute;
      top: 12px;
      left: -20px;
      width: 11px;
      height: 9px;
    }
  }

  &-main {
    @include tablet {
      display: block;
      >li {
        width: 100%;
        margin-bottom: 40px;
        &:nth-child(3n+1),
        &:nth-child(3n+2),
        &:nth-child(3n+3) {
          width: 100%;
        }
      }
    }
    @include mobile {
      >li {
        margin-top: 67px;
        margin-bottom: 10px;
        &:nth-child(1) {
          margin-top: 0;
          margin-bottom: 37px;
        }
        &:nth-child(6) {
          margin-bottom: 37px;
        }
      }
    }
    margin-bottom: 12px;
  } // END .footer-list-main;

  &-simple {

    a {
      display: inline-block;
      position: relative;
    }

    @include screen('md') {
      bottom: 0;
      left: 0;
      position: absolute;
      width: 100%;
    }
  } // END .footer-list-simple;
}
.footer-socials {
  li {
    display: inline-block;
    margin-right: 5px;
    a {
      position: relative;
      svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.input-wrapper {
  color: $text-light;
  margin-bottom: $gap-xs;
  padding: 10px 0;
  border-bottom: 1px solid $text-light;
  @include clearfix();

  input {
    background-color: transparent;
    border: none;
    color: $text-light;
    width: calc(100% - 120px);
    &:focus {
      outline: none;
    }
    &::placeholder {
      color: $text-light;
      font-size: 12px;
    }
  }
  button {
    background-color: transparent;
    color: $text-light;
    border: none;
    box-shadow: none;
    text-align: right;
    text-transform: uppercase;
    float: right;
    cursor: pointer;
    &:focus {
      outline: none;
    }
    &:hover {
      color: $text-accent;
    }
  }
  .has-error & {
    border-color: $color-error;

    input {
      color: $color-error;
    }
  }
}
.copy {
  display: block;
  text-align: center;
  margin-bottom: $gap-sm;
  a {
    color: $color-inverted;

    &:hover, &:focus {
      text-decoration: underline;
    }
  }

  @include screen ($tablet-width) {
    overflow: hidden;

    &-left {
      float: left;
      text-align: left;
    }
    &-right {
      float: right;
      text-align: right;
    }
  }
}
</style>
